import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/logos.png';
import _imports_1 from '../../assets/images/addr.svg';
import _imports_2 from '../../assets/images/phone.svg';
import _imports_3 from '../../assets/images/mail.svg';
import _imports_4 from '../../assets/images/net.svg';
import _imports_5 from '../../assets/images/bg.png';
import _imports_6 from '@/assets/unlock-bg.png';
import _imports_7 from '@/assets/unlock-vip.png';
const _withScopeId = n => (_pushScopeId("data-v-75efac29"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "detail"
};
const _hoisted_2 = {
  class: "info"
};
const _hoisted_3 = {
  class: "sch-top"
};
const _hoisted_4 = {
  class: "logo"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "right"
};
const _hoisted_7 = {
  class: "sch-name"
};
const _hoisted_8 = {
  class: "major"
};
const _hoisted_9 = {
  class: "major"
};
const _hoisted_10 = {
  class: "item"
};
const _hoisted_11 = {
  class: "collegeName"
};
const _hoisted_12 = {
  class: "item"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "image",
  src: _imports_1
}, null, -1));
const _hoisted_14 = {
  class: "tags"
};
const _hoisted_15 = {
  class: "item"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "image",
  src: _imports_2
}, null, -1));
const _hoisted_17 = {
  class: "sch-button"
};
const _hoisted_18 = {
  class: "item"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "image",
  src: _imports_3
}, null, -1));
const _hoisted_20 = {
  class: "item"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "image",
  src: _imports_4
}, null, -1));
const _hoisted_22 = {
  class: "button-left"
};
const _hoisted_23 = {
  style: {
    "display": "flex",
    "justify-content": "flex-start",
    "align-items": "center",
    "font-size": "14px"
  }
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "已被", -1));
const _hoisted_25 = {
  class: "bottom"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bg",
  src: _imports_5
}, null, -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "rg",
  src: _imports_5
}, null, -1));
const _hoisted_29 = {
  class: "con"
};
const _hoisted_30 = {
  class: "upload"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "down-tips"
}, "导出时间约为5分钟,可到邮箱查看", -1));
const _hoisted_32 = {
  class: "dialog-footer"
};
const _hoisted_33 = {
  class: "upload"
};
const _hoisted_34 = {
  class: "dialog-footer"
};
const _hoisted_35 = {
  class: "intention"
};
const _hoisted_36 = {
  key: 0
};
const _hoisted_37 = {
  style: {
    "margin-top": "-10px"
  }
};
const _hoisted_38 = {
  class: "fl-space-between-center"
};
const _hoisted_39 = {
  class: "mt10"
};
const _hoisted_40 = {
  class: "mt10"
};
const _hoisted_41 = {
  class: "mt10"
};
const _hoisted_42 = {
  key: 1,
  class: "upload"
};
const _hoisted_43 = {
  key: 0,
  class: "dialog-footer"
};
const _hoisted_44 = {
  class: "upload mt30"
};
const _hoisted_45 = {
  class: "fl-end"
};
const _hoisted_46 = {
  class: "fl-start-center"
};
const _hoisted_47 = {
  class: "unlock"
};
const _hoisted_48 = {
  class: "unlock-content"
};
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6
}, null, -1));
const _hoisted_50 = {
  class: "unlock-main"
};
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-title"
}, "解锁信息", -1));
const _hoisted_52 = {
  class: "unlock-bg"
};
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "unlock-vip"
}, null, -1));
const _hoisted_54 = {
  style: {
    "width": "580px"
  }
};
const _hoisted_55 = {
  class: "unlock-tips1"
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "研可岸择校网上线后免费服务了上百万用户", -1));
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mt10"
}, [/*#__PURE__*/_createTextVNode(" 过高成本无法长久运营，决定每位用户将 "), /*#__PURE__*/_createElementVNode("span", null, "收费1元 (拼团)")], -1));
const _hoisted_58 = {
  class: "mt10"
};
const _hoisted_59 = {
  class: "fl-center"
};
const _hoisted_60 = {
  class: "unlock-step"
};
const _hoisted_61 = {
  class: "fl-start-center"
};
const _hoisted_62 = {
  class: "unlock-step-top"
};
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-step-top-title"
}, "step1", -1));
const _hoisted_64 = {
  class: "unlock-step-top-content fl-start-center"
};
const _hoisted_65 = ["src"];
const _hoisted_66 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-step-top-text"
}, [/*#__PURE__*/_createElementVNode("div", null, "微信扫码"), /*#__PURE__*/_createElementVNode("div", {
  class: "mt5"
}, "支付费用")], -1));
const _hoisted_67 = {
  class: "unlock-step-top ml10"
};
const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-step-top-title"
}, "step2", -1));
const _hoisted_69 = {
  class: "unlock-step-top-content fl-start-center"
};
const _hoisted_70 = ["src"];
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-step-top-text"
}, [/*#__PURE__*/_createElementVNode("div", null, "微信扫码"), /*#__PURE__*/_createElementVNode("div", {
  class: "mt5"
}, "复制订单号")], -1));
const _hoisted_72 = {
  class: "unlock-step-bottom mt20"
};
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-step-bottom-title"
}, "step3", -1));
const _hoisted_74 = {
  class: "unlock-step-bottom-content fl-start-center"
};
const _hoisted_75 = {
  class: "mt40 fl-space-between-center"
};
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-tips2"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "tips-title"
}, "Q：为什么我的订单号激活失效？"), /*#__PURE__*/_createElementVNode("div", {
  class: "tips-subtitle"
}, " A：拼团订单只有拼团成功后才能激活 ")], -1));
const _hoisted_77 = {
  class: "unlock-service"
};
const _hoisted_78 = {
  class: "unlock-service-code"
};
const _hoisted_79 = ["src"];
const _hoisted_80 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-service-title"
}, "扫码联系客服", -1));
const _hoisted_81 = {
  class: "unlock"
};
const _hoisted_82 = {
  class: "unlock-content"
};
const _hoisted_83 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6
}, null, -1));
const _hoisted_84 = {
  class: "unlock-main"
};
const _hoisted_85 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-title"
}, "解锁信息", -1));
const _hoisted_86 = {
  class: "unlock-bg"
};
const _hoisted_87 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "unlock-vip"
}, null, -1));
const _hoisted_88 = {
  style: {
    "width": "580px"
  }
};
const _hoisted_89 = {
  class: "unlock-tips1"
};
const _hoisted_90 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mt10"
}, " 如您需要继续查询，可以扫下方二维码购买查询次数 ", -1));
const _hoisted_91 = {
  class: "fl-center"
};
const _hoisted_92 = {
  class: "unlock-step"
};
const _hoisted_93 = {
  class: "fl-start-center"
};
const _hoisted_94 = {
  class: "unlock-step-top"
};
const _hoisted_95 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-step-top-title"
}, "step1", -1));
const _hoisted_96 = {
  class: "unlock-step-top-content fl-start-center"
};
const _hoisted_97 = ["src"];
const _hoisted_98 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-step-top-text"
}, [/*#__PURE__*/_createElementVNode("div", null, "微信扫码"), /*#__PURE__*/_createElementVNode("div", {
  class: "mt5"
}, "支付费用")], -1));
const _hoisted_99 = {
  class: "unlock-step-top ml10"
};
const _hoisted_100 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-step-top-title"
}, "step2", -1));
const _hoisted_101 = {
  class: "unlock-step-top-content fl-start-center"
};
const _hoisted_102 = ["src"];
const _hoisted_103 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-step-top-text"
}, [/*#__PURE__*/_createElementVNode("div", null, "微信扫码"), /*#__PURE__*/_createElementVNode("div", {
  class: "mt5"
}, "复制订单号")], -1));
const _hoisted_104 = {
  class: "unlock-step-bottom mt20"
};
const _hoisted_105 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-step-bottom-title"
}, "step3", -1));
const _hoisted_106 = {
  class: "unlock-step-bottom-content fl-start-center"
};
const _hoisted_107 = {
  class: "mt40 fl-center"
};
const _hoisted_108 = {
  class: "unlock-service"
};
const _hoisted_109 = {
  class: "unlock-service-code"
};
const _hoisted_110 = ["src"];
const _hoisted_111 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-service-title"
}, "扫码联系客服", -1));
const _hoisted_112 = {
  class: "upload"
};
const _hoisted_113 = {
  class: "dialog-footer"
};
const _hoisted_114 = {
  class: "code-content"
};
const _hoisted_115 = {
  class: "code-img"
};
const _hoisted_116 = ["src"];
const _hoisted_117 = {
  class: "code-text"
};
const _hoisted_118 = {
  style: {
    "width": "280px",
    "height": "320px",
    "text-align": "center"
  }
};
const _hoisted_119 = ["src"];
const _hoisted_120 = ["src"];
const _hoisted_121 = ["onClick"];
const _hoisted_122 = {
  class: "title-mask"
};
import { Warning, CirclePlus, CloseBold, CircleCheck, View } from "@element-plus/icons-vue";
import { ref, onMounted, reactive, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import maskLayer from "@/components/maskLayer/maskLayer.vue";
import Enroll from "./component/Enroll.vue";
import ExamPaper from "./component/ExamPaper.vue";
import ExamScope from "./component/ExamScope.vue";
import RecruitStudent from "./component/RecruitStudent.vue";
import Score from "./component/Score.vue";
import StudentAnalysis from "./component/StudentAnalysis.vue";
import { schoolDetail, changeWrong, tipsVip, changeUnlock, changeUnlockAugment, QRcode, activationVip, vipBecomeDueTime, applyInfo, allSchool, allMajor, volunteerCount, deleteInfo, volunteerList, getAdId, exportMajorData, connectUs } from "@/api/api";
import { decrypt } from "@/utils/parseDate";
import { ElMessage, ElMessageBox } from "element-plus";
import "element-plus/theme-chalk/el-message-box.css";
import { useStore } from "vuex";
export default {
  __name: 'detail',
  setup(__props) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const organizationDialog = ref(false);
    const formOrganization = ref({});
    const formOrganizationRef = ref();
    // 表单规则
    const rulesOrganization = {
      email: [{
        required: true,
        message: "请填写邮箱地址",
        trigger: "blur"
      }, {
        type: "email",
        message: "请填写正确邮箱地址",
        trigger: ["blur", "change"]
      }]
    };
    const showAboutDialog = ref(false);
    function showAbout() {
      showAboutDialog.value = true;
    }
    // 激活新的会员
    async function onTipsClick() {
      if (unlockForm.value.yzOid == "") {
        ElMessage({
          message: "请填写E开头订单号",
          type: "warning",
          showClose: true
        });
        return;
      }
      buttonLoading.value = true;
      const result = await changeUnlockAugment(unlockForm.value);
      const deRes = JSON.parse(decrypt(result));
      console.log(deRes);
      if (deRes.status === 0) {
        unlockForm.value.yzOid = "";
        ElMessage.success("激活成功!");
        buttonLoading.value = false;
        store.commit("setTipsDialog", false);
        callChildMethod();
      } else {
        ElMessage({
          message: deRes.msg,
          type: "warning",
          showClose: true
        });
        buttonLoading.value = false;
      }
    }
    function onTipsClose() {
      store.commit("setTipsDialog", false);
    }
    // 联系我们
    const connectUsdata = ref("");
    // 联系我们
    async function getConnectUs() {
      try {
        const data = await connectUs();
        if (data.status === 0) {
          connectUsdata.value = JSON.parse(data.result);
        }
      } catch (error) {}
    }
    function toAgreement(params) {
      let url = router.resolve({
        path: `/school/agreement/agreement`,
        query: {
          type: params.type,
          name: params.name
        }
      }).href;
      window.open(url);
    }
    function handleOrganizationClose() {
      organizationDialog.value = false;
    }
    function confirmOrganization() {
      try {
        formOrganizationRef.value.validate(async res => {
          if (res) {
            let data = {
              majorOutRelationId: majorId.majorOutRelationId,
              email: formOrganization.value.email
            };
            const result = await exportMajorData(data);
            const deRes = JSON.parse(decrypt(result));
            console.log(deRes);
            if (deRes.status === 0) {
              ElMessage.success("导出中,请稍后到邮箱查看!");
              organizationDialog.value = !organizationDialog.value;
            }
          }
        });
      } catch (error) {
        organizationDialog.value = false;
      }
    }
    function onExportMajorData() {
      organizationDialog.value = !organizationDialog.value;
    }
    // 显示遮罩层
    const visible = ref(false);
    const adData = ref({});
    async function showMask() {
      const data = await getAdId();
      if (data.status === 0) {
        try {
          let adImage = data.result == null ? [] : JSON.parse(data.result);
          if (adImage.length > 0) {
            adData.value = adImage[0];
            // 判断是否显示广告，仅在adData.value有效时进行比较
            if (adData.value && store.state.adId == adData.value.adId) {
              visible.value = false;
            } else {
              visible.value = true;
            }
          } else {
            visible.value = false;
          }
        } catch (e) {
          console.error("JSON解析错误:", e);
          visible.value = false;
        }
      }
    }
    function navigate(item) {
      if (item.jumpUrl == "") {
        ElMessage.warning("暂无跳转链接!");
        return;
      }
      window.open(item.jumpUrl, "_blank");
    }
    function onMaskClose() {
      nextTick(() => {
        window.localStorage.setItem("adId", adData.value.adId);
        store.commit("setAdId", adData.value.adId);
        visible.value = false;
      });
    }
    // 当前激活tab
    const active = ref(0);
    const activeCom = ref(Enroll);
    const formRef = ref();

    // 专业id
    const majorId = reactive({
      majorOutRelationId: route.query.majorOutRelationId
    });
    // 学校信息
    const schoolObj = ref({
      contactRsp: {},
      schoolTags: []
    });
    // 纠错弹窗
    const wrongDialog = ref(false);
    // 显示纠错弹窗
    function showWrong() {
      form.value = {
        schoolName: schoolObj.value.schoolName,
        webSiteUrl: schoolObj.value.contactRsp.wz,
        majorName: schoolObj.value.majorName,
        majorCode: schoolObj.value.majorCode,
        collegeName: schoolObj.value.collegeName,
        majorOutRelationId: majorId.majorOutRelationId
      };
      wrongDialog.value = !wrongDialog.value;
    }
    // 意向志愿弹框
    const isSchoolDelete = ref(false);
    const isMajorEmpty = ref(false);
    const intentionDialog = ref(false);
    const formRefIntention = ref();
    const schoolOptions = ref([]);
    const majorOptions = ref([]);
    const formIntention = ref({
      applyOutRelationId: "",
      benMajorCode: "",
      benMajorName: "",
      benSchoolCode: "",
      benSchoolName: "",
      twoFightFlag: ""
    });
    // 表单规则
    const rulesIntention = {
      benSchoolName: [{
        required: true,
        message: "请选择学校!",
        trigger: "blur"
      }],
      benMajorName: [{
        required: true,
        message: "请选择专业!",
        trigger: "blur"
      }],
      twoFightFlag: [{
        required: true,
        message: "请选择是否二战!",
        trigger: "blur"
      }]
    };
    function onIntentionDialog() {
      isSchoolDelete.value = false;
      console.log(IntentionLoading.value);
      if (IntentionLoading.value) return;
      if (IntentionShow.value) {
        ElMessage({
          message: "您已设置过意向志愿，请勿重复设置",
          type: "warning",
          showClose: true
        });
        return;
      }
      if (volunteerArr.value.length >= 3) {
        ElMessage({
          message: "只允许设置三条志愿",
          type: "warning",
          showClose: true
        });
        isSchoolDelete.value = true;
        intentionDialog.value = !intentionDialog.value;
        return;
      }
      ElMessageBox.confirm("需要先设置该院校专业为目标志愿才能查看，是否设置？", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        title: "提示",
        type: "warning",
        center: true
      }).then(() => {
        intentionDialog.value = !intentionDialog.value;
        formIntention.value = {
          applyOutRelationId: majorId.majorOutRelationId,
          benMajorCode: studentInfoRsp.value.benMajorCode == undefined ? "" : studentInfoRsp.value.benMajorCode,
          benMajorName: studentInfoRsp.value.benMajorName == undefined ? "" : studentInfoRsp.value.benMajorName,
          benSchoolCode: studentInfoRsp.value.benSchoolCode == undefined ? "" : studentInfoRsp.value.benSchoolCode,
          benSchoolName: studentInfoRsp.value.benSchoolName == undefined ? "" : studentInfoRsp.value.benSchoolName,
          twoFightFlag: studentInfoRsp.value.twoFightFlag == undefined ? "" : studentInfoRsp.value.twoFightFlag
        };
        console.log(formIntention.value);
        if (studentInfoRsp.value.benSchoolCode) {
          getAllMajor(studentInfoRsp.value.benSchoolCode);
        }
        getAllSchool();
      }).catch(() => {
        ElMessage({
          type: "info",
          message: "已取消"
        });
      });
    }
    const targetChecked = ref(false);
    const targetDialog = ref(false);
    const volunteerArr = ref([]);
    const studentInfoRsp = ref({});
    async function getVolunteerList() {
      try {
        const result = await volunteerList();
        const res = JSON.parse(decrypt(result));
        console.log(res, "List");
        if (res.status === 0 && res.result) {
          studentInfoRsp.value = res.result.studentInfoRsp;
          volunteerArr.value = res.result.intentionMajorRsp;
          for (let index = 0; index < res.result.intentionMajorRsp.length; index++) {
            const item = res.result.intentionMajorRsp[index];
            if (item.majorOutRelationId === JSON.parse(majorId.majorOutRelationId)) {
              IntentionShow.value = true;
              return;
            }
          }
        } else {
          targetDialog.value = store.state.isVip && !store.state.noMore;
          if (targetDialog.value) {
            formIntention.value.applyOutRelationId = majorId.majorOutRelationId;
            getAllSchool();
          }
          console.log(targetDialog.value, 999);
        }
      } catch (error) {
        // throw new Error(error)
      }
    }
    function targetDialogClose() {
      targetDialog.value = false;
      if (targetChecked.value) {
        store.commit("setNoMore", true);
      }
    }
    async function onDeleteIntention(item, index) {
      const result = await deleteInfo({
        applyOutRelationId: item.majorOutRelationId
      });
      const deRes = JSON.parse(decrypt(result));
      console.log(deRes);
      if (deRes.status === 0) {
        ElMessage.success("删除成功!");
        volunteerArr.value.splice(index, 1);
        console.log(volunteerArr.value.length);
        if (volunteerArr.value.length == 0) {
          isSchoolDelete.value = false;
          formIntention.value = {
            applyOutRelationId: majorId.majorOutRelationId,
            benMajorCode: studentInfoRsp.value.benMajorCode == undefined ? "" : studentInfoRsp.value.benMajorCode,
            benMajorName: studentInfoRsp.value.benMajorName == undefined ? "" : studentInfoRsp.value.benMajorName,
            benSchoolCode: studentInfoRsp.value.benSchoolCode == undefined ? "" : studentInfoRsp.value.benSchoolCode,
            benSchoolName: studentInfoRsp.value.benSchoolName == undefined ? "" : studentInfoRsp.value.benSchoolName,
            twoFightFlag: studentInfoRsp.value.twoFightFlag == undefined ? "" : studentInfoRsp.value.twoFightFlag
          };
          console.log(formIntention.value);
          if (studentInfoRsp.value.benSchoolCode) {
            getAllMajor(studentInfoRsp.value.benSchoolCode);
          }
          getAllSchool();
        }
      } else {
        ElMessage({
          message: deRes.msg,
          type: "warning",
          showClose: true
        });
        buttonLoading.value = false;
      }
    }
    async function getAllSchool() {
      const res = await allSchool();
      if (res.status === 0) {
        schoolOptions.value = res.result;
      }
    }
    async function getAllMajor(code) {
      isMajorEmpty.value = false;
      const res = await allMajor({
        schoolCode: code
      });
      if (res.status === 0) {
        majorOptions.value = res.result;
        isMajorEmpty.value = res.result.length === 0 ? true : false;
      }
    }
    function onMajorChange(val) {
      majorOptions.value.forEach(item => {
        if (item.majorCode === val) {
          formIntention.value.benMajorCode = item.majorCode;
          formIntention.value.benMajorName = item.majorName;
        }
      });
    }
    function onSchoolChange(val) {
      majorOptions.value = [];
      formIntention.value.benMajorCode = "";
      formIntention.value.benMajorName = "";
      schoolOptions.value.forEach(item => {
        if (item.schoolCode === val) {
          formIntention.value.benSchoolCode = item.schoolCode;
          formIntention.value.benSchoolName = item.schoolName;
          getAllMajor(item.schoolCode);
        }
      });
    }
    function onRadioChange(params) {
      console.log(params);
    }
    // 纠错表单
    const form = ref({
      schoolName: "",
      majorName: ""
    });
    // 解锁按钮
    const buttonLoading = ref(false);
    // 解锁表单
    const unlockForm = ref({
      yzOid: ""
    });
    function onChangeUnlock() {
      store.commit("setUnlockDialog", true);
    }
    // 跳转编辑详情页
    function toEditDetail() {
      let url = router.resolve({
        path: `/school/edit/EditDetailPage`,
        query: {
          majorOutRelationId: majorId.majorOutRelationId
        }
      }).href;
      window.open(url);
    }
    // 关闭解锁弹框
    function onUnlockClose() {
      store.commit("setUnlockDialog", false);
    }
    const childRef = ref();
    const callChildMethod = () => {
      childRef.value.childMethod();
    };
    async function onUnlockClick() {
      if (unlockForm.value.yzOid == "") {
        ElMessage({
          message: "请填写E开头订单号",
          type: "warning",
          showClose: true
        });
        return;
      }
      buttonLoading.value = true;
      const result = await changeUnlock(unlockForm.value);
      const deRes = JSON.parse(decrypt(result));
      console.log(deRes);
      if (deRes.status === 0) {
        unlockForm.value.yzOid = "";
        ElMessage.success("激活成功!");
        buttonLoading.value = false;
        store.commit("setUnlockDialog", false);
        callChildMethod();
      } else {
        ElMessage({
          message: deRes.msg,
          type: "warning",
          showClose: true
        });
        buttonLoading.value = false;
      }
    }
    // tab列表
    const tabList = [{
      label: "录取名单",
      value: 0,
      component: Enroll
    }, {
      label: "分数分析",
      value: 1,
      component: Score
    }, {
      label: "招生人数",
      value: 2,
      component: RecruitStudent
    }, {
      label: "考试范围",
      value: 3,
      component: ExamScope
    }, {
      label: "考生分析",
      value: 4,
      component: StudentAnalysis
    }
    // {
    //   label: "考研真题",
    //   value: 5,
    //   component: ExamPaper,
    // },
    ];
    // tab 点击
    function clickTab(el) {
      active.value = el.value;
      activeCom.value = el.component;
    }

    // 表单规则
    const rules = {
      schoolName: [{
        required: true,
        message: "请输入学校名称!",
        trigger: "blur"
      }],
      collegeName: [{
        required: true,
        message: "请输入学校名称!",
        trigger: "blur"
      }],
      majorName: [{
        required: true,
        message: "请输入专业名称!",
        trigger: "blur"
      }],
      majorCode: [{
        required: true,
        message: "请输入专业代码!",
        trigger: "blur"
      }],
      wz: [{
        required: true,
        message: "请输入官网链接!",
        trigger: "blur"
      }],
      content: [{
        required: true,
        message: "请输入错误信息!",
        trigger: "blur"
      }]
    };
    function showLoginModal() {}
    // 确认就错
    function confirmWrong() {
      try {
        formRef.value.validate(async res => {
          if (res) {
            const result = await changeWrong(form.value);
            const deRes = JSON.parse(decrypt(result));
            if (deRes.status === 0) {
              ElMessage.success("提交成功!");
              wrongDialog.value = !wrongDialog.value;
            }
          }
        });
      } catch (error) {
        wrongDialog.value = false;
      }
    }
    const IntentionShow = ref(false);
    const IntentionLoading = ref(false);
    const RelationIdList = ref([]);
    // 确认添加意向志愿
    function confirmIntention() {
      try {
        formRefIntention.value.validate(async res => {
          if (res) {
            IntentionLoading.value = true;
            const result = await applyInfo(formIntention.value);
            const deRes = JSON.parse(decrypt(result));
            console.log(deRes);
            if (deRes.status === 0) {
              getVolunteerList();
              getVolunteerCount();
              ElMessage.success("添加成功!");
              targetDialog.value = false;
              if (targetChecked.value) {
                store.commit("setNoMore", true);
              }
              IntentionShow.value = true;
              intentionDialog.value = false;
              setTimeout(() => {
                IntentionLoading.value = false;
              }, 500);
            } else {
              ElMessage.warning("添加失败，请联系管理员!");
            }
          }
        });
      } catch (error) {
        intentionDialog.value = false;
      }
    }

    // 获取学校详情
    async function getSchoolDetail() {
      try {
        const result = await schoolDetail({
          majorOutRelationId: majorId.majorOutRelationId
        });
        const res = JSON.parse(decrypt(result));
        console.log(res);
        if (res.status === 0) {
          schoolObj.value = res.result;
        }
      } catch (e) {
        goHome();
      }
    }
    function goHome() {
      router.push({
        name: "school"
      });
    }
    function handleClose() {
      wrongDialog.value = false;
    }
    function handleIntentionClose() {
      intentionDialog.value = false;
      targetDialog.value = false;
    }
    const QRcodeImage = ref("");
    // 获取小程序二维码
    async function getQRcode() {
      try {
        const result = await QRcode();
        if (result.status === 0) {
          QRcodeImage.value = JSON.parse(result.result);
        }
      } catch (error) {
        // throw new Error(error)
      }
    }
    const tipsStep1 = ref("");
    const tipsStep2 = ref("");
    const tipsKeFuUrl = ref("");
    // 获取激活引导图片
    async function getTipsActivationVip() {
      try {
        const result = await tipsVip();
        if (result.status === 0) {
          let res = JSON.parse(result.result);
          console.log(res);
          tipsStep1.value = res.step1;
          tipsStep2.value = res.step2;
          tipsKeFuUrl.value = res.keFuUrl;
        }
      } catch (error) {
        // throw new Error(error)
      }
    }
    const step1 = ref("");
    const step2 = ref("");
    const keFuUrl = ref("");
    // 获取激活引导图片
    async function getActivationVip() {
      try {
        const result = await activationVip();
        if (result.status === 0) {
          let res = JSON.parse(result.result);
          console.log(res);
          step1.value = res.step1;
          step2.value = res.step2;
          keFuUrl.value = res.keFuUrl;
        }
      } catch (error) {
        // throw new Error(error)
      }
    }
    const count = ref(0);
    // 今年新增多少人将该学校专业加入志愿
    async function getVolunteerCount() {
      try {
        const data = {
          majorOutRelationId: majorId.majorOutRelationId
        };
        const result = await volunteerCount(data);
        const res = JSON.parse(decrypt(result));
        console.log(res, "count");
        if (res.status === 0 && res.result) {
          count.value = res.result == null ? 0 : res.result;
        }
      } catch (error) {
        // throw new Error(error)
      }
    }
    onMounted(() => {
      getConnectUs();
      getVolunteerList();
      getVolunteerCount();
      getActivationVip();
      getTipsActivationVip();
      getSchoolDetail();
      getQRcode();
      showMask();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_link = _resolveComponent("el-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "top"
      }, [_createElementVNode("img", {
        class: "logo",
        onClick: goHome,
        style: {
          "cursor": "pointer"
        },
        src: _imports_0
      })]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
        class: "logo-img",
        src: schoolObj.value.logoUrl
      }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(schoolObj.value.schoolName), 1), _createElementVNode("span", _hoisted_8, _toDisplayString(schoolObj.value.majorName) + "(" + _toDisplayString(schoolObj.value.majorCode) + ")", 1), _createElementVNode("span", _hoisted_9, _toDisplayString(schoolObj.value.learningStyleName), 1), _createElementVNode("span", {
        class: "wrong",
        onClick: showWrong
      }, "纠错"), _unref(store).state.isOrganization == 'true' ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        onClick: onExportMajorData,
        type: "success",
        style: {
          "margin-left": "10px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(" 导出专业报告 ")]),
        _: 1
      })) : _createCommentVNode("", true), _createElementVNode("span", {
        class: "wrong",
        onClick: toEditDetail,
        style: {
          "margin-left": "10px"
        }
      }, "编辑")]), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(schoolObj.value.collegeName), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("span", null, _toDisplayString(schoolObj.value.provinceName), 1)]), _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schoolObj.value.schoolTags, ele => {
        return _openBlock(), _createElementBlock("div", {
          class: "ele",
          key: ele
        }, _toDisplayString(ele), 1);
      }), 128))]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("span", null, "学校电话: " + _toDisplayString(schoolObj.value.contactRsp?.dh), 1)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("span", null, "电子邮箱: " + _toDisplayString(schoolObj.value.contactRsp?.yx), 1)]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("span", null, "学校网址: " + _toDisplayString(schoolObj.value.contactRsp?.wz), 1)])]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_el_tag, {
        type: "danger",
        size: "large"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_hoisted_24, IntentionShow.value != true ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          style: {
            "margin-left": "2px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_unref(View))]),
          _: 1
        })) : _createCommentVNode("", true), _createElementVNode("div", null, _toDisplayString(IntentionShow.value ? count.value : "") + "人加入考研目标志愿", 1)])]),
        _: 1
      }), !IntentionShow.value ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        onClick: onIntentionDialog,
        type: "danger",
        style: {
          "margin-left": "10px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(" 查看 ")]),
        _: 1
      })) : _createCommentVNode("", true)])])])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("ul", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabList, ele => {
        return _createElementVNode("li", {
          class: _normalizeClass({
            active: ele.value === active.value
          }),
          key: ele.value,
          onClick: $event => clickTab(ele)
        }, _toDisplayString(ele.label), 11, _hoisted_26);
      }), 64))])]), _hoisted_27, _hoisted_28]), _createElementVNode("div", _hoisted_29, [(_openBlock(), _createBlock(_resolveDynamicComponent(activeCom.value), {
        majorId: majorId.majorOutRelationId,
        onOnChange: onChangeUnlock,
        ref_key: "childRef",
        ref: childRef
      }, null, 40, ["majorId"]))]), _createVNode(_component_el_dialog, {
        modelValue: organizationDialog.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => organizationDialog.value = $event),
        title: "导出专业报告",
        width: "25%",
        "before-close": handleOrganizationClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_32, [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => organizationDialog.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirmOrganization
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_30, [_hoisted_31, _createVNode(_component_el_form, {
          ref_key: "formOrganizationRef",
          ref: formOrganizationRef,
          model: formOrganization.value,
          rules: rulesOrganization,
          class: "demo-ruleForm",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "邮箱地址",
            prop: "email"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formOrganization.value.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formOrganization.value.email = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: wrongDialog.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => wrongDialog.value = $event),
        title: "纠错信息",
        width: "40%",
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_34, [_createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = $event => wrongDialog.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirmWrong
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form.value,
          rules: rules,
          "label-width": "120px",
          class: "demo-ruleForm",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "学校名称",
            prop: "schoolName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.schoolName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.schoolName = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "院系名称",
            prop: "collegeName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.collegeName,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.collegeName = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "专业名称",
            prop: "majorName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.majorName,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.majorName = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "专业代码",
            prop: "majorCode"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.majorCode,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.majorCode = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "官网链接",
            prop: "webSiteUrl"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.webSiteUrl,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.webSiteUrl = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "错误信息",
            prop: "content"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.content,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.value.content = $event),
              type: "textarea"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])])]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_35, [_createVNode(_component_el_dialog, {
        modelValue: intentionDialog.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => intentionDialog.value = $event),
        title: isSchoolDelete.value ? '查看意向志愿' : '添加意向志愿',
        width: "30%",
        "before-close": handleIntentionClose
      }, {
        footer: _withCtx(() => [!isSchoolDelete.value ? (_openBlock(), _createElementBlock("span", _hoisted_43, [_createVNode(_component_el_button, {
          onClick: _cache[15] || (_cache[15] = $event => intentionDialog.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: IntentionLoading.value,
          type: "primary",
          onClick: confirmIntention
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }, 8, ["loading"])])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [isSchoolDelete.value ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(volunteerArr.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "mt20"
          }, [_createVNode(_component_el_card, {
            shadow: "hover"
          }, {
            header: _withCtx(() => [_createElementVNode("div", _hoisted_38, [_createElementVNode("span", null, "意向志愿" + _toDisplayString(index + 1), 1), _createVNode(_component_el_button, {
              size: "small",
              type: "danger",
              plain: "",
              onClick: $event => onDeleteIntention(item, index),
              icon: _unref(CloseBold),
              circle: ""
            }, null, 8, ["onClick", "icon"])])]),
            default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", null, "意向学校：" + _toDisplayString(item.schoolName), 1), _createElementVNode("div", _hoisted_39, "意向学院：" + _toDisplayString(item.collegeName), 1), _createElementVNode("div", _hoisted_40, " 意向专业：" + _toDisplayString(item.majorName) + " (" + _toDisplayString(item.majorCode) + ") ", 1), _createElementVNode("div", _hoisted_41, " 学习方式：" + _toDisplayString(item.applyLearningStyleDesc), 1)])]),
            _: 2
          }, 1024)]);
        }), 128))])])) : (_openBlock(), _createElementBlock("div", _hoisted_42, [_createVNode(_component_el_form, {
          ref_key: "formRefIntention",
          ref: formRefIntention,
          rules: rulesIntention,
          model: formIntention.value,
          class: "demo-ruleForm",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "本科学校",
            prop: "benSchoolName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formIntention.value.benSchoolName,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => formIntention.value.benSchoolName = $event),
              clearable: "",
              placeholder: "请选择本科学校",
              onChange: onSchoolChange,
              style: {
                "width": "100%"
              },
              filterable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schoolOptions.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.schoolCode,
                  label: item.schoolName,
                  value: item.schoolCode
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "本科专业",
            prop: "benMajorName"
          }, {
            default: _withCtx(() => [isMajorEmpty.value ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              clearable: "",
              modelValue: formIntention.value.benMajorName,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => formIntention.value.benMajorName = $event),
              placeholder: "暂无数据，可手动输入"
            }, null, 8, ["modelValue"])) : (_openBlock(), _createBlock(_component_el_select, {
              key: 1,
              modelValue: formIntention.value.benMajorName,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => formIntention.value.benMajorName = $event),
              clearable: "",
              onChange: onMajorChange,
              placeholder: "请选择本科专业",
              style: {
                "width": "100%"
              },
              filterable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(majorOptions.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.majorCode,
                  label: item.majorName,
                  value: item.majorCode
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"]))]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "是否二战",
            prop: "twoFightFlag"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: formIntention.value.twoFightFlag,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => formIntention.value.twoFightFlag = $event),
              onChange: onRadioChange
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: true
              }, {
                default: _withCtx(() => [_createTextVNode("是")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: false
              }, {
                default: _withCtx(() => [_createTextVNode("否")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]))]),
        _: 1
      }, 8, ["modelValue", "title"])]), _createElementVNode("div", null, [_createVNode(_component_el_dialog, {
        modelValue: targetDialog.value,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => targetDialog.value = $event),
        title: "设置考研目标",
        width: "30%",
        "before-close": targetDialogClose
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createVNode(_component_el_button, {
          onClick: targetDialogClose
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: IntentionLoading.value,
          type: "primary",
          onClick: confirmIntention
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_checkbox, {
          style: {
            "margin-left": "10px"
          },
          type: "danger",
          modelValue: targetChecked.value,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => targetChecked.value = $event),
          border: ""
        }, {
          default: _withCtx(() => [_createTextVNode("不再提示")]),
          _: 1
        }, 8, ["modelValue"])])])]),
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "danger",
          icon: _unref(Warning)
        }, {
          default: _withCtx(() => [_createTextVNode("完成考研目标设置，后续可能会收到更多相关院校信息推送")]),
          _: 1
        }, 8, ["icon"]), _createElementVNode("div", _hoisted_44, [_createVNode(_component_el_form, {
          ref_key: "formRefIntention",
          ref: formRefIntention,
          rules: rulesIntention,
          model: formIntention.value,
          class: "demo-ruleForm",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "本科学校",
            prop: "benSchoolName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formIntention.value.benSchoolName,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => formIntention.value.benSchoolName = $event),
              clearable: "",
              placeholder: "请选择本科学校",
              onChange: onSchoolChange,
              style: {
                "width": "100%"
              },
              filterable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schoolOptions.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.schoolCode,
                  label: item.schoolName,
                  value: item.schoolCode
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "本科专业",
            prop: "benMajorName"
          }, {
            default: _withCtx(() => [isMajorEmpty.value ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              clearable: "",
              modelValue: formIntention.value.benMajorName,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => formIntention.value.benMajorName = $event),
              placeholder: "暂无数据，可手动输入"
            }, null, 8, ["modelValue"])) : (_openBlock(), _createBlock(_component_el_select, {
              key: 1,
              modelValue: formIntention.value.benMajorName,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => formIntention.value.benMajorName = $event),
              clearable: "",
              onChange: onMajorChange,
              placeholder: "请选择本科专业",
              style: {
                "width": "100%"
              },
              filterable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(majorOptions.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.majorCode,
                  label: item.majorName,
                  value: item.majorCode
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"]))]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "是否二战",
            prop: "twoFightFlag"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: formIntention.value.twoFightFlag,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => formIntention.value.twoFightFlag = $event),
              onChange: onRadioChange
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: true
              }, {
                default: _withCtx(() => [_createTextVNode("是")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: false
              }, {
                default: _withCtx(() => [_createTextVNode("否")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])])]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_47, [_createVNode(_component_el_dialog, {
        modelValue: _unref(store).state.unlockDialog,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => _unref(store).state.unlockDialog = $event),
        width: "670",
        "align-center": "",
        "before-close": onUnlockClose
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_48, [_createVNode(_component_el_icon, {
          onClick: onUnlockClose,
          color: "#f92f60",
          class: "no-inherit"
        }, {
          default: _withCtx(() => [_createVNode(_unref(CloseBold))]),
          _: 1
        }), _hoisted_49, _createElementVNode("div", _hoisted_50, [_hoisted_51, _createElementVNode("div", _hoisted_52, [_hoisted_53, _createElementVNode("div", _hoisted_54, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_55, [_hoisted_56, _hoisted_57, _createElementVNode("div", _hoisted_58, [_createVNode(_component_el_button, {
          type: "success"
        }, {
          default: _withCtx(() => [_createTextVNode("限时优惠")]),
          _: 1
        })])]), _createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_hoisted_63, _createElementVNode("div", _hoisted_64, [_createElementVNode("img", {
          src: step1.value,
          class: "unlock-step-top-code"
        }, null, 8, _hoisted_65), _hoisted_66])]), _createElementVNode("div", _hoisted_67, [_hoisted_68, _createElementVNode("div", _hoisted_69, [_createElementVNode("img", {
          src: step2.value,
          class: "unlock-step-top-code"
        }, null, 8, _hoisted_70), _hoisted_71])])]), _createElementVNode("div", _hoisted_72, [_hoisted_73, _createElementVNode("div", _hoisted_74, [_createElementVNode("div", null, [_createVNode(_component_el_input, {
          class: "unlock-step-bottom-input",
          clearable: "",
          modelValue: unlockForm.value.yzOid,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => unlockForm.value.yzOid = $event),
          placeholder: "输入E开头订单号"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
          class: "unlock-step-bottom-button",
          color: "#f5c98f",
          dark: true,
          loading: buttonLoading.value,
          onClick: onUnlockClick
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }, 8, ["loading"])])])])])])]), _createElementVNode("div", _hoisted_75, [_hoisted_76, _createElementVNode("div", _hoisted_77, [_createElementVNode("div", _hoisted_78, [_createElementVNode("img", {
          src: keFuUrl.value
        }, null, 8, _hoisted_79)]), _hoisted_80])])])])])])]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_81, [_createVNode(_component_el_dialog, {
        modelValue: _unref(store).state.tipsDialog,
        "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => _unref(store).state.tipsDialog = $event),
        width: "670",
        "align-center": "",
        "before-close": onTipsClose
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_82, [_createVNode(_component_el_icon, {
          onClick: onTipsClose,
          color: "#f92f60",
          class: "no-inherit"
        }, {
          default: _withCtx(() => [_createVNode(_unref(CloseBold))]),
          _: 1
        }), _hoisted_83, _createElementVNode("div", _hoisted_84, [_hoisted_85, _createElementVNode("div", _hoisted_86, [_hoisted_87, _createElementVNode("div", _hoisted_88, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_89, [_createElementVNode("div", null, [_createTextVNode(" 注意：您的查询次数已达到上限，详情可查看👉 "), _createVNode(_component_el_link, {
          style: {
            "font-weight": "bold"
          },
          type: "success",
          onClick: _cache[25] || (_cache[25] = $event => toAgreement({
            type: 8905,
            name: '用户协议'
          }))
        }, {
          default: _withCtx(() => [_createTextVNode("用户协议")]),
          _: 1
        })]), _hoisted_90]), _createElementVNode("div", _hoisted_91, [_createElementVNode("div", _hoisted_92, [_createElementVNode("div", _hoisted_93, [_createElementVNode("div", _hoisted_94, [_hoisted_95, _createElementVNode("div", _hoisted_96, [_createElementVNode("img", {
          src: tipsStep1.value,
          class: "unlock-step-top-code"
        }, null, 8, _hoisted_97), _hoisted_98])]), _createElementVNode("div", _hoisted_99, [_hoisted_100, _createElementVNode("div", _hoisted_101, [_createElementVNode("img", {
          src: tipsStep2.value,
          class: "unlock-step-top-code"
        }, null, 8, _hoisted_102), _hoisted_103])])]), _createElementVNode("div", _hoisted_104, [_hoisted_105, _createElementVNode("div", _hoisted_106, [_createElementVNode("div", null, [_createVNode(_component_el_input, {
          class: "unlock-step-bottom-input",
          clearable: "",
          modelValue: unlockForm.value.yzOid,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => unlockForm.value.yzOid = $event),
          placeholder: "输入E开头订单号"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
          class: "unlock-step-bottom-button",
          color: "#f5c98f",
          dark: true,
          loading: buttonLoading.value,
          onClick: onTipsClick
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }, 8, ["loading"])])])])])])]), _createElementVNode("div", _hoisted_107, [_createElementVNode("div", _hoisted_108, [_createElementVNode("div", _hoisted_109, [_createElementVNode("img", {
          src: tipsKeFuUrl.value
        }, null, 8, _hoisted_110)]), _hoisted_111])])])])])])]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_112, [_createVNode(_component_el_dialog, {
        modelValue: _unref(store).state.numberDialog,
        "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => _unref(store).state.numberDialog = $event),
        title: "查询次数过多",
        width: "530",
        "destroy-on-close": "",
        center: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_113, [_createVNode(_component_el_button, {
          onClick: _cache[29] || (_cache[29] = $event => _unref(store).state.numberDialog = false)
        }, {
          default: _withCtx(() => [_createTextVNode("关闭")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", null, [_createTextVNode(" 每天最多查询100次，超过次数后需要24小时后再查，请查看 "), _createVNode(_component_el_link, {
          style: {
            "font-weight": "bold"
          },
          type: "success",
          onClick: _cache[28] || (_cache[28] = $event => toAgreement({
            type: 8905,
            name: '用户协议'
          }))
        }, {
          default: _withCtx(() => [_createTextVNode("👉用户协议")]),
          _: 1
        })])]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_114, [_createElementVNode("div", _hoisted_115, [_createElementVNode("img", {
        src: QRcodeImage.value.url,
        style: {
          "width": "120px",
          "height": "120px"
        }
      }, null, 8, _hoisted_116)]), _createElementVNode("div", _hoisted_117, [_createVNode(_component_el_button, {
        type: "success"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(QRcodeImage.value.tips), 1)]),
        _: 1
      })])]), _createVNode(_component_el_dialog, {
        width: "320px",
        modelValue: showAboutDialog.value,
        "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => showAboutDialog.value = $event)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_118, [_createElementVNode("img", {
          style: {
            "width": "240px",
            "height": "240px"
          },
          src: connectUsdata.value.content
        }, null, 8, _hoisted_119)])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(maskLayer, {
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => visible.value = $event),
        center: "",
        "append-to-body": ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "ad-image",
          onClick: _cache[32] || (_cache[32] = $event => navigate(adData.value))
        }, [_createElementVNode("img", {
          src: adData.value.imgUrl,
          style: {
            "width": "895px",
            "height": "381px"
          }
        }, null, 8, _hoisted_120), _createElementVNode("div", {
          class: "ad-close",
          onClick: _withModifiers(onMaskClose, ["stop"])
        }, [_createVNode(_component_el_button, {
          type: "danger",
          icon: _unref(CloseBold),
          circle: ""
        }, null, 8, ["icon"])], 8, _hoisted_121), _createElementVNode("div", _hoisted_122, [_createElementVNode("div", null, _toDisplayString(adData.value.title), 1)])])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};